import axiosConfig from "./axiosConfig";

/**
 * Envoie un message de contact
 * @param {Object} data - Les données du formulaire de contact
 * @param {string} data.firstname - Prénom de l'expéditeur
 * @param {string} data.lastname - Nom de l'expéditeur
 * @param {string} data.email_sender - Adresse email de l'expéditeur
 * @param {string} data.message - Message envoyé
 * @param {string} data.organization - Nom de l'organisation
 */
export const sendMail = async (data) => {
    try {
        const payload = {
            firstname: data.firstname,
            lastname: data.lastname,
            email_sender: data.email_sender,
            message: data.message,
            organization: data.organization
        };

        const response = await axiosConfig.post("v1/contact", payload);
        return response.data;
    } catch (error) {
        console.error("Erreur lors de l'envoi du message de contact:", error.response?.data || error.message);
        throw error;
    }
};
